import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = {
  key: 1,
  class: "app__loader"
}

import "@/assets/scss/normalize.scss";
import "@/assets/scss/vars.scss";
import "./App.scss";
import {useUserStore} from "@/stores/userStore";
import {onBeforeUnmount, onMounted} from "vue";
import {useNotificationsStore} from "@/stores/notificationsStore";
import Alerts from "@/components/Alerts/Alerts.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let userStore = useUserStore();
let notificationsStore = useNotificationsStore();

onMounted(() => {
	userStore.startUpdating();
	notificationsStore.startUpdating();
});

onBeforeUnmount(() => {
	userStore.stopUpdating();
	notificationsStore.stopUpdating();
});


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userStore).loaded)
      ? (_openBlock(), _createBlock(_component_RouterView, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2)),
    _createVNode(Alerts)
  ]))
}
}

})